import * as css from 'css/exports.module.scss';
import './SearchFilterContainer.scss';
import { Card, Row } from 'antd';
import React from 'react';
export const SearchFilterContainer = ({ children }) => React.createElement(Card, { className: 'periscope-search-filters' },
    React.createElement(Row, { align: 'middle', gutter: [Number(css.size8), Number(css.size8)] }, children));
